<template>
  <div>
    <div id="doc">
      <video id="my-player" controls preload="none" :autoplay="videoData.autoplay" :poster="videoData.poster">
        <source :src="videoData.url" :type="videoData.fileType" />
      </video>
    </div>
  </div>
</template>

<script>
import config from "@/config/";

export default {
  name: "ModalPreviewVideo",

  props: {
    currentDocumento: {
      type: Object,
      default: () => ({})
    },
    toAppendStgAccessKey: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      videoData: {
        autoplay: false,
        poster: null,
        url: null,
        fileType: "video/mp4"
      },
      stgAccessKey: "",
    };
  },

  created() {
    if (this.toAppendStgAccessKey) {
      this.stgAccessKey = config.CD_STG_ACCESS_KEY;
    }

    this.videoData.autoplay = !!this.currentDocumento.autoplay;
    this.videoData.poster = this.currentDocumento.poster || "/img/cp_logooficial_fondoNEGRO.png";
    this.videoData.url = this.currentDocumento.documento + this.stgAccessKey;
    this.videoData.fileType = this.currentDocumento.fileType || "video/mp4";
  }
};
</script>

<style scoped>
#doc {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

#my-player {
  text-align: center;
  margin: 0 auto;
  width: 100%;
}
</style>
